// docs/ux-operativa-v2-spec.md RF-3. Pide confirmación antes de recargar o
// salir de una pantalla con datos cargados sin guardar.
//
// Cada pantalla registra una guarda con `proteger({ hayCambios })` al montarse
// y la da de baja al desmontarse. Puede haber más de una activa a la vez
// (una vista y un panel dentro de ella).
const guardias = new Set()
let instalado = false
let salidaAutorizada = false
let vencimientoAutorizacion = null

const MENSAJE = 'Hay datos cargados que todavía no se guardaron. Si salís, se pierden.'

function hayCambios() {
  for (const guardia of guardias) {
    try {
      if (guardia.hayCambios()) return true
    } catch (_) {
      // Una guarda rota no debe bloquear la navegación.
    }
  }
  return false
}

function consumirAutorizacion() {
  const autorizada = salidaAutorizada
  salidaAutorizada = false
  window.clearTimeout(vencimientoAutorizacion)
  return autorizada
}

// F5, Ctrl+R, cerrar la pestaña: el navegador muestra su propio aviso (el
// texto no se puede personalizar).
function onBeforeUnload(event) {
  if (salidaAutorizada || !hayCambios()) return
  event.preventDefault()
  event.returnValue = ''
}

export function instalar(router) {
  if (instalado) return
  window.addEventListener('beforeunload', onBeforeUnload)
  router.beforeEach(async (to, from) => {
    if (consumirAutorizacion()) return true
    if (to.path === from.path || !hayCambios()) return true
    return Boolean(await window.confirm(MENSAJE, {
      title: 'Salir sin guardar',
      confirmText: 'Salir sin guardar',
      cancelText: 'Seguir cargando'
    }))
  })
  instalado = true
}

/**
 * Registra una guarda. Devuelve la función de baja.
 * @param {{ hayCambios: () => boolean }} params
 */
export function proteger({ hayCambios: fn } = {}) {
  if (typeof fn !== 'function') {
    throw new Error('salidaProtegidaService.proteger requiere hayCambios')
  }
  const guardia = { hayCambios: fn }
  guardias.add(guardia)
  return function desproteger() {
    guardias.delete(guardia)
  }
}

// Para salidas que ya confirmaron o que salen tras guardar: deja pasar la
// próxima navegación sin preguntar. Es de un solo uso y vence sola, porque
// `$router.back()` no devuelve promesa y la navegación podría no ocurrir.
export function autorizarSalida() {
  salidaAutorizada = true
  window.clearTimeout(vencimientoAutorizacion)
  vencimientoAutorizacion = window.setTimeout(() => { salidaAutorizada = false }, 2000)
}

export default { instalar, proteger, autorizarSalida }
